export const jobs = [
  {
    id: "property-consultant",
    title: "Property Consultant (Fresher)",
    location: "Ahmedabad, Gujarat",
    type: "Full-time",
    salary: "₹15,000 – ₹25,000 + Incentives",
    experience: "0 - 1 Year",
    description:
      "We are looking for a motivated Property Consultant to assist clients in buying and selling real estate properties.",
    responsibilities: [
      "Handle incoming property inquiries",
      "Schedule site visits with clients",
      "Explain property features and pricing",
      "Build long-term client relationships"
    ],
    skills: [
      "Good communication skills",
      "Basic knowledge of real estate",
      "Sales mindset",
      "Client handling"
    ]
  },
  {
    id: "digital-marketing-executive",
    title: "Digital Marketing Executive",
    location: "Ahmedabad, Gujarat",
    type: "Full-time",
    salary: "₹18,000 – ₹30,000",
    experience: "0 - 2 Years",
    description:
      "We are looking for a creative digital marketer to manage campaigns and generate property leads.",
    responsibilities: [
      "Run Facebook & Google ads",
      "Manage social media pages",
      "Generate leads for property sales",
      "Track campaign performance"
    ],
    skills: [
      "Meta Ads",
      "Google Ads",
      "SEO basics",
      "Content creation"
    ]
  }
];